/**
 * Connector Types
 *
 * Shared connector identifiers for Losi Code / CLI coding agent auth cards.
 * Kept free of DOM APIs so server tools can import them safely.
 */

// --------------

export type LosiConnectorType =
  | 'github_app'
  | 'kiro_cli'
  | 'codex_cli'
  | 'claude_code'
  | 'repo_link'

export const LOSI_CONNECTOR_LABELS: Record<LosiConnectorType, string> = {
  github_app: 'GitHub',
  kiro_cli: 'Kiro CLI',
  codex_cli: 'Codex CLI',
  claude_code: 'Claude Code',
  repo_link: 'Repository'
}
